import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

// initial state
const state = {
    data: [
        {
            id_tipo: 1,
            nome: 'Seleção única'
        },
        {
            id_tipo: 2,
            nome: 'Seleção múltipla'
        },
        {
            id_tipo: 3,
            nome: 'Campo texto aberto'
        },
        {
            id_tipo: 4,
            nome: 'Campo numérico'
        },
        {
            id_tipo: 5,
            nome: 'Níveis'
        },
        {
            id_tipo: 6,
            nome: 'Seleção distrito'
        },
        {
            id_tipo: 7,
            nome: 'Setores atividade'
        },
        {
            id_tipo: 8,
            nome: 'Campo texto longo'
        },
    
    ]
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_tipo == id})
    }
}

const actions = {}

const mutations = {}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/tipos.js